import WarningIcon from '@mui/icons-material/WarningAmberRounded'
import CalendarIcon from '@mui/icons-material/CalendarMonthOutlined'
import ClockIcon from '@mui/icons-material/AccessTimeOutlined'
import TruckIcon from '@mui/icons-material/LocalShippingOutlined'
import ServiceIcon from '@mui/icons-material/HandymanOutlined'
import ScaleIcon from '@mui/icons-material/ScaleOutlined'

import { QuoteConstraint } from '../../../modules/quotes'
import { mergeClassName } from '../../../utils/mergeClassName'

type ConstraintIconProps = {
  constraint: QuoteConstraint
  className?: string
}

export const ConstraintIcon: React.FC<ConstraintIconProps> = ({
  constraint,
  className,
}) => {
  switch (constraint) {
    case QuoteConstraint.unavailableDate:
      return <CalendarIcon className={mergeClassName('!text-[22px]', className)} />
    case QuoteConstraint.unavailablePreferredTime:
      return <ClockIcon className={mergeClassName('!text-[22px]', className)} />
    case QuoteConstraint.notEnoughTrucks:
      return <TruckIcon className={mergeClassName('!text-[22px]', className)} />
    case QuoteConstraint.additionalServicesNotOffered:
    case QuoteConstraint.specialServicesNotOffered:
      return <ServiceIcon className={mergeClassName('!text-[22px]', className)} />
    case QuoteConstraint.specialItemsNotSupported:
      return <ScaleIcon className={mergeClassName('!text-[19px]', className)} />
    default:
      return <WarningIcon className={mergeClassName('!text-[22px]', className)} />
  }
}
